var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisa = function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#005397",
    fillRule: "evenodd",
    d: "M26.192 13.333c1.252 0 2.258.267 2.897.511l-.438 2.64-.29-.139a5.8 5.8 0 0 0-2.42-.468c-1.267 0-1.852.542-1.853 1.048-.008.572.686.946 1.816 1.51 1.866.87 2.728 1.922 2.716 3.31-.026 2.527-2.234 4.16-5.631 4.16-1.451-.016-2.849-.31-3.603-.65l.452-2.725.416.193c1.064.455 1.752.64 3.046.64.93 0 1.927-.375 1.936-1.19.005-.534-.419-.915-1.679-1.512-1.226-.582-2.852-1.558-2.832-3.308.02-2.367 2.27-4.02 5.467-4.02m11.192.225 2.617 12.17H37s-.297-1.4-.394-1.824h-.545l-.338-.001h-.188l-.4-.001-1.063-.002h-.409l-.192-.001h-.509l-.498-.002-.264.708-.098.265-.317.858h-3.397l4.802-11.16c.34-.795.92-1.01 1.695-1.01zm-18.001-.012L17.36 25.724h-3.234l2.023-12.178zm-4.543.01L9.747 25.712l-3.422.002L3.43 15.063c2.053 1.056 3.89 3.163 4.48 5.108l.338 1.688 3.165-8.303zm20.273 3.284c-.163.457-.449 1.194-.43 1.162 0 0-1.02 2.704-1.288 3.404h2.684c-.127-.608-.748-3.515-.748-3.515z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F79510",
    fillRule: "evenodd",
    d: "M5.354 13.333H.044L0 13.594c4.132 1.045 6.865 3.566 8 6.596l-1.154-5.793c-.199-.799-.777-1.036-1.492-1.064",
    clipRule: "evenodd"
  })));
};
export default SvgVisa;